import {
  SET_SELECTED_INSTITUTE_IDS,
  SET_INSTITUTES,
  UPDATE_INSTITUTE,
  ADD_INSTITUTE,
  DELETE_INSTITUTE,
  InstituteActionTypes,
  InstituteState,
  Institute,
  InstituteById,
} from '../types';

const initialState: InstituteState = {
  selectedInstituteIds: [], // this field is used by zerpatable checkbox hook. see useCheckbox hook
  allIds: undefined,
  byId: undefined,
};

function setNormalizedInstitutes(
  state: InstituteState, instituteList: Institute[],
): InstituteState {
  const allIds: number[] = [];
  const byId = instituteList.reduce((accumulator, current) => {
    accumulator[current.id] = current;
    allIds.push(current.id);
    return accumulator;
  }, {} as InstituteById);
  return {
    ...state,
    byId,
    allIds,
  };
}

function updateNormalizedInstitute(state: InstituteState, institute: Institute) {
  return {
    ...state,
    byId: {
      ...state.byId,
      [institute.id]: institute,
    },
  } as InstituteState;
}

function addNormalizedInstitute(state: InstituteState, institute: Institute) {
  return {
    ...state,
    byId: {
      ...state.byId,
      [institute.id]: institute,
    },
    allIds: state.allIds ? state.allIds.concat([institute.id]) : [institute.id],
  } as InstituteState;
}

function deleteNormalizedInstitute(state: InstituteState, instituteId: number): InstituteState {
  const { byId: instituteByid, allIds } = state;
  if (instituteByid && allIds) {
    const { [instituteId]: _del, ...rest } = instituteByid;
    const newIds = [...allIds];
    newIds.splice(newIds.indexOf(instituteId), 1);
    return {
      ...state,
      byId: rest,
      allIds: newIds,
    } as InstituteState;
  }
  return state;
}

function InstituteReducer(state = initialState, action: InstituteActionTypes): InstituteState {
  switch (action.type) {
    case SET_SELECTED_INSTITUTE_IDS:
      return { ...state, selectedInstituteIds: action.payload };
    case SET_INSTITUTES:
      return setNormalizedInstitutes(state, action.payload);
    case UPDATE_INSTITUTE:
      return updateNormalizedInstitute(state, action.payload);
    case ADD_INSTITUTE:
      return addNormalizedInstitute(state, action.payload);
    case DELETE_INSTITUTE:
      return deleteNormalizedInstitute(state, action.payload);
    default:
      return state;
  }
}

export default InstituteReducer;
